import { Link } from 'react-router-dom'

import { appRoutes } from '@/constants'
import { cn } from '@/lib/utils'

export interface BrandProps {
  to?: string
  className?: string
}

function Brand({ to = appRoutes.home, className }: BrandProps) {
  const content = (
    <span className={cn('flex items-center gap-2.5', className)}>
      <img
        src="/images/logo.png"
        alt="Exotic Autocart"
        className="h-10 sm:h-12 w-auto object-contain transition-transform group-hover:scale-105"
      />
    </span>
  )

  if (!to) {
    return content
  }

  return (
    <Link to={to} className="group inline-flex items-center" aria-label="Dealer Commerce Home">
      {content}
    </Link>
  )
}

export { Brand }